module.exports = __webpack_public_path__ + "img/grate-droplet.eb9be0f2.svg";